import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {baseUrl, userLocation} from "../Univ.js";
function OpInvoice() {
    const {sale_op} = useParams();
    const [opbillData, setOpbillData] = useState([]);
    const [hospData, setHospData] = useState([]);
    const [appointmentData, setAppointmentData] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            try {
                // ====================================================
                // GET OP INVOICE
                // ====================================================
                const invoiceResponse = await axios.get(`${baseUrl}op-invoice/${sale_op}`);
                const invoiceData = Array.isArray(invoiceResponse.data) ? invoiceResponse.data : [];
                setOpbillData(invoiceData);
                // ====================================================
                // GET APPOINTMENT
                // ====================================================
                if (invoiceData.length > 0) {
                    const apptId = invoiceData[0]?.appt_id;
                    if (apptId) {
                        try {
                            const appointmentResponse = await axios.get(`${baseUrl}view-appt/${apptId}`);
                            const appointmentResult = appointmentResponse.data;
                            if (Array.isArray(appointmentResult)) {
                                setAppointmentData(appointmentResult.length > 0 ? appointmentResult[0] : null);
                            } else {
                                setAppointmentData(appointmentResult || null);
                            }
                        } catch (appointmentError) {
                            console.error("Appointment fetch error:", appointmentError);
                            setAppointmentData(null);
                        }
                    }
                }
                // ====================================================
                // GET HOSPITAL
                // ====================================================
                const hospitalResponse = await axios.get(`${baseUrl}view-hospital/${userLocation}/`);
                setHospData(Array.isArray(hospitalResponse.data) ? hospitalResponse.data : []);
            } catch (error) {
                console.error("Invoice fetch error:", error);
                setOpbillData([]);
                setHospData([]);
                setAppointmentData(null);
            }
        };
        if (sale_op) {
            fetchData();
        }
    }, [sale_op]);
    // ============================================================
    // PRINT
    // ============================================================
    const handlePrint = () => {
        const printContents = document.getElementById("invoice-print").innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
    };
    // ============================================================
    // NUMBER TO WORDS
    // ============================================================
    function numberToWords(num) {
        const units = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];
        const teens = ["eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
        const tens = ["", "ten", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
        const scales = ["", "thousand", "million", "billion", "trillion", "quadrillion", "quintillion", "sextillion", "septillion", "octillion", "nonillion", "decillion"];
        num = Number(num);
        if (isNaN(num)) {
            return "zero rupees only";
        }
        if (num === 0) {
            return "zero rupees only";
        }
        if (num < 0) {
            return `negative ${numberToWords(Math.abs(num))}`;
        }
        function convertThreeDigitsLessThanThousand(value) {
            if (value === 0) {
                return "";
            }
            if (value < 10) {
                return units[value];
            }
            if (value >= 11 && value <= 19) {
                return teens[value - 11];
            }
            const onesDigit = value % 10;
            const tensDigit = Math.floor((value % 100) / 10);
            const hundredsDigit = Math.floor(value / 100);
            let result = "";
            if (hundredsDigit > 0) {
                result = `${units[hundredsDigit]} hundred`;
            }
            if (tensDigit > 0) {
                if (result) {
                    result += " and ";
                }
                if (tensDigit === 1) {
                    if (onesDigit > 0) {
                        result += teens[onesDigit - 1];
                    } else {
                        result += "ten";
                    }
                } else if (onesDigit === 0) {
                    result += tens[tensDigit];
                } else {
                    result += `${tens[tensDigit]}-${units[onesDigit]}`;
                }
            } else if (onesDigit > 0) {
                if (result) {
                    result += " and ";
                }
                result += units[onesDigit];
            }
            return result;
        }
        function convertInteger(value) {
            if (value === 0) {
                return "zero";
            }
            let words = "";
            let scaleIndex = 0;
            while (value > 0) {
                const current = value % 1000;
                if (current !== 0) {
                    const currentWords = convertThreeDigitsLessThanThousand(current);
                    if (scaleIndex > 0) {
                        words = `${currentWords} ${scales[scaleIndex]} ${words}`;
                    } else {
                        words = `${currentWords} ${words}`;
                    }
                }
                value = Math.floor(value / 1000);
                scaleIndex++;
            }
            return words.trim();
        }
        const fixedNumber = Number(num).toFixed(2);
        const parts = fixedNumber.split(".");
        const integerPart = parseInt(parts[0], 10);
        const decimalPart = parseInt(parts[1], 10);
        let words = convertInteger(integerPart);
        if (decimalPart > 0) {
            words += " and ";
            if (decimalPart < 10) {
                words += units[decimalPart];
            } else if (decimalPart >= 11 && decimalPart <= 19) {
                words += teens[decimalPart - 11];
            } else {
                const decimalTens = Math.floor(decimalPart / 10);
                const decimalOnes = decimalPart % 10;
                if (decimalOnes === 0) {
                    words += tens[decimalTens];
                } else {
                    words += `${tens[decimalTens]}-${units[decimalOnes]}`;
                }
            }
            words += " paisa";
        }
        return `${words} rupees only`;
    }
    // ============================================================
    // RENDER
    // ============================================================
    return (<section>
        <div>

            {opbillData.map((row, index) => {
                // ====================================================
                // APPOINTMENT TYPE
                // ====================================================
                const appointmentType = String(appointmentData?.type || appointmentData?.appointment_type || "")
                    .toLowerCase()
                    .trim();
                const isNew = appointmentType === "new";
                // ====================================================
                // AMOUNTS
                // ====================================================
                const totalFee = parseFloat(row?.fee) || 0;
                const registrationFee = isNew ? 50 : 0;
                const consultantFee = isNew ? Math.max(totalFee - registrationFee, 0) : totalFee;
                const paidAmount = parseFloat(row?.paid) || 0;
                // ====================================================
                // SAFE VALUES
                // ====================================================
                const patientName = row?.pat?.patient || "-";
                const patientId = row?.pat?.pat_id || "-";
                const consultant = row?.cons?.consultant || "-";
                const invoiceNumber = row?.invoice || "-";
                const invoiceDate = row?.add_date || "-";
                const paymentMode = row?.mode ? String(row.mode)
                    .charAt(0)
                    .toUpperCase() + String(row.mode).slice(1) : "";
                const cashier = row?.cashier || "-";
                return (<div
                    id="invoice-print"
                    key={row?.id || index}
                >

                    {/* =================================================
                                HOSPITAL HEADER
                            ================================================= */}

        {/* =================================================
                HOSPITAL HEADER
            ================================================= */}

<div
    style={{
        width: "100%",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        lineHeight: 0
    }}
>
    {hospData.map((hospital) => (
        <img
            key={hospital.id}
            src={hospital.logo}
            alt="Hospital Header"
            style={{
                width: "100%",
                height: "110px",
                display: "block",
                margin: 0,
                padding: 0,
                border: "none",
                objectFit: "fill"
            }}
        />
    ))}
</div>


{/* =================================================
                PATIENT / INVOICE DETAILS
            ================================================= */}

<div
    style={{
        width: "100%",
        margin: "8px 0 0 0",
        padding: "8px 12px",
        boxSizing: "border-box",
        borderTop: "1px solid #333",
        borderBottom: "1px solid #333",
        fontSize: "14px",
        lineHeight: "1.5"
    }}
>
    <div
        style={{
            display: "flex",
            width: "100%",
            alignItems: "flex-start"
        }}
    >

        {/* =========================
                PATIENT DETAILS
            ========================= */}

        <div
            style={{
                width: "55%",
                paddingRight: "15px",
                boxSizing: "border-box",
                borderRight: "1px solid #999"
            }}
        >
            <div style={{ marginBottom: "3px" }}>
                <strong>Name :</strong>&nbsp;
                {patientName}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>PID :</strong>&nbsp;
                {patientId}
            </div>

            <div>
                <strong>Consultant :</strong>&nbsp;
                Dr. {consultant}
            </div>
        </div>


        {/* =========================
                INVOICE DETAILS
            ========================= */}

        <div
            style={{
                width: "45%",
                paddingLeft: "15px",
                boxSizing: "border-box"
            }}
        >
            <div style={{ marginBottom: "3px" }}>
                <strong>Invoice No # :</strong>&nbsp;
                {invoiceNumber}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>Date :</strong>&nbsp;
                {invoiceDate}
            </div>

            <div>
                <strong>{paymentMode} Receipt</strong>
            </div>
        </div>

    </div>
</div>

                    {/* =================================================
                                BILL TABLE
                            ================================================= */}

                    <div>

                        <table
                            border="2"
                            rules="rows"
                            cellPadding="3"
                            className="text-justify mt-4"
                            width="100%"
                        >

                            <thead>

                            <tr
                                style={{
                                    backgroundColor: "#1bc5ce", color: "white"
                                }}
                            >

                                <th align="left">
                                    S.No
                                </th>

                                <th align="left">
                                    Particulars
                                </th>

                                <th align="left">
                                    Amount
                                </th>

                            </tr>

                            </thead>


                            <tbody>

                            {/* =================================================
                                            REGISTRATION FEE
                                        ================================================= */}

                            {isNew && (<tr>

                                <td
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    1
                                </td>

                                <td
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    <b>
                                        Registration Fee
                                    </b>
                                </td>

                                <td
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    <b>
                                        <i
                                            className="fa fa-inr"
                                            aria-hidden="true"
                                        ></i>
                                        &nbsp;
                                        {registrationFee.toFixed(2)}
                                    </b>
                                </td>

                            </tr>)}


                            {/* =================================================
                                            CONSULTANT / OP FEE
                                        ================================================= */}

                            <tr>

                                <td
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    {isNew ? 2 : 1}
                                </td>

                                <td
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    <b>
                                        {isNew ? "Consultant Fee" : "Op Fees"}
                                    </b>
                                </td>

                                <td
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    <b>
                                        <i
                                            className="fa fa-inr"
                                            aria-hidden="true"
                                        ></i>
                                        &nbsp;
                                        {consultantFee.toFixed(2)}
                                    </b>
                                </td>

                            </tr>


                            {/* =================================================
                                            INVOICED AMOUNT
                                        ================================================= */}

                            <tr>

                                <td align="center"></td>

                                <td
                                    align="left"
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    <b>
                                        Invoiced Amount
                                    </b>
                                </td>

                                <td
                                    align="left"
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    <b>
                                        <i
                                            className="fa fa-inr"
                                            aria-hidden="true"
                                        ></i>
                                        &nbsp;
                                        {totalFee.toFixed(2)}
                                    </b>
                                </td>

                            </tr>


                            {/* =================================================
                                            DISCOUNT
                                        ================================================= */}

                            {row?.disc !== 0 && row?.disc !== "" && row?.disc !== null && row?.disc !== undefined && (
                                <tr>

                                    <td align="center"></td>

                                    <td
                                        align="left"
                                        style={{
                                            border: "1px solid", borderColor: "#2194d9"
                                        }}
                                    >
                                        <b>
                                            Discount Amount
                                        </b>
                                    </td>

                                    <td
                                        align="left"
                                        style={{
                                            border: "1px solid", borderColor: "#2194d9"
                                        }}
                                    >
                                        <b
                                            style={{
                                                color: "red"
                                            }}
                                        >
                                            <i
                                                className="fa fa-inr"
                                                aria-hidden="true"
                                            ></i>
                                            &nbsp;
                                            {row.disc}
                                        </b>
                                    </td>

                                </tr>)}


                            {/* =================================================
                                            PAID AMOUNT
                                        ================================================= */}

                            <tr>

                                <td align="center"></td>

                                <td
                                    align="left"
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    <b>
                                        Paid Amount
                                    </b>
                                </td>

                                <td
                                    align="left"
                                    style={{
                                        border: "1px solid", borderColor: "#2194d9"
                                    }}
                                >
                                    <b>
                                        <i
                                            className="fa fa-inr"
                                            aria-hidden="true"
                                        ></i>
                                        &nbsp;
                                        {row?.paid || 0}
                                    </b>
                                </td>

                            </tr>


                            {/* =================================================
                                            BALANCE
                                        ================================================= */}

                            {row?.balance != 0 && row?.balance != "" && row?.balance != null && row?.balance != undefined && (
                                <tr>

                                    <td align="center"></td>

                                    <td
                                        align="left"
                                        style={{
                                            border: "1px solid", borderColor: "#2194d9"
                                        }}
                                    >
                                        <b>
                                            Balance Amount
                                        </b>
                                    </td>

                                    <td
                                        align="left"
                                        style={{
                                            border: "1px solid", borderColor: "#2194d9"
                                        }}
                                    >
                                        <b>
                                            <i
                                                className="fa fa-inr"
                                                aria-hidden="true"
                                            ></i>
                                            &nbsp;
                                            {row.balance}
                                        </b>
                                    </td>

                                </tr>)}

                            </tbody>

                        </table>


                        {/* =================================================
                                    AMOUNT IN WORDS
                                ================================================= */}

                        <p className="mt-2 p-3 text-bold">
                            Received the sum of{" "}
                            {numberToWords(paidAmount)}.
                        </p>


                        {/* =================================================
                                    CASHIER
                                ================================================= */}

                        <div
                            style={{
                                display: "flex", justifyContent: "right", alignItems: "right"
                            }}
                        >

                            <tr>

                                <th>
                                    {cashier}
                                </th>

                                <br/>

                                <th
                                    style={{
                                        width: "200px", borderTop: "2px solid black"
                                    }}
                                >
                                    Cashier
                                </th>

                            </tr>

                        </div>

                    </div>

                </div>);
            })}


            {/* ============================================================
                    PRINT BUTTON
                ============================================================ */}

            <div
                style={{
                    display: "flex", justifyContent: "center", alignItems: "center"
                }}
            >

                <button
                    style={{
                        padding: "5px 20px", borderRadius: "10px", backgroundColor: "#007bff", color: "#fff"
                    }}
                    onClick={handlePrint}
                >
                    Print
                </button>

            </div>

        </div>
    </section>);
}
export default OpInvoice;